import axios from 'axios';
import { setAlert } from './alert';
import { GET_LOG, LOG_ERROR } from './types';

export const getLog = () => async dispatch => {
    try{
        const res = await axios.get('/api/log/getLog');
        dispatch({
            type: GET_LOG,
            payload: res.data
        });
    }catch(err){
        const errors = err.response && err.response.data && err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: LOG_ERROR
        });
    }
};
